import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import FormContainer from '../components/FormContainer';
import Loader from '../components/Loader';
import { useResetPasswordMutation } from '../slices/usersApiSlice';

const PasswordResetScreen = () => {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [resetPassword] = useResetPasswordMutation();

    const submitHandler = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(''); // Clear any previous errors
        setSuccess(''); // Clear any previous success messages

        try {
            await resetPassword({ email }).unwrap();
            setSuccess('Check your email for password reset instructions.');
            setEmail('');  // Clear the email field after successful submission
        } catch (err) {
            setError(err?.data?.message || "Failed to send password reset email.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <FormContainer>
            <h3>Reset Password</h3>

            {error && (
                <Alert variant="danger" onClose={() => setError('')} dismissible>
                    {error}
                </Alert>
            )}

            {success && (
                <Alert variant="success" onClose={() => setSuccess('')} dismissible>
                    {success}
                </Alert>
            )}

            <Form onSubmit={submitHandler}>
                <Form.Group controlId="email" className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setError(''); // Clear error when user types
                            setSuccess(''); // Clear success message when user types
                        }}
                        required
                        className="mb-2"
                    />
                </Form.Group>

                <Button
                    type="submit"
                    className="mt-2 blue-outline"
                    disabled={isLoading}
                >
                    Send Reset Link
                </Button>

                {isLoading && <Loader />}
            </Form>

            <Row className="py-3">
                <Col>
                    Remembered your password? <Link to="/login">Login</Link>
                </Col>
            </Row>
        </FormContainer>
    );
};

export default PasswordResetScreen;